import React from 'react';
import { useSelector } from 'react-redux';

import { Layout } from 'common/components/layout';
import { useLocalization } from 'redux/localization/utils/hooks';

const NotFound = () => {
  const settings = useSelector((state) => state.setting.data);
  const { t } = useLocalization();

  return (
    <>
      <Layout
        title={t('products.general.collectionNotFoundTitle')}
        description={t('products.general.collectionNotFoundTitle')}
      >
        <section className="c7-content c7-error-page">
          <h1 className="c7-h1">
            {t('products.general.collectionNotFoundTitle')}
          </h1>
          <p>
            {t('products.general.collectionNotFoundMessage')}{' '}
            <a href={settings.continueShopping}>
              {t('products.general.notFoundMessageLink')}
            </a>{' '}
            {t('products.general.collectionNotFoundMessage2')}
          </p>
        </section>
      </Layout>
    </>
  );
};

export default NotFound;
